import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from '../../common';
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    GET_INDUSTRY_CPD_CATEGORY: undefined,
    API: {
      GET_INDUSTRY_CPD_CATEGORY: apiResourceActionCreator('industryCpdCategory')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(`${API_ENDPOINT}/get-industry-cpd-category`, authToken, action.admin.api.getIndustryCpdCategory)

function* getIndustryCpdCategory(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken));
}

const configuration = {
  name: 'getIndustryCpdCategory',
  action: action,
  sagas: getIndustryCpdCategory,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingIndustryCpdCategory: true
    }),
    success: (state, action) => ({
      ...state,
      isFetchingIndustryCpdCategory: false,
      industryCpdCategory: action.payload.industryCpdCategory
    }),
    failed: (state, action) => ({
      ...state,
      isFetchingIndustryCpdCategory: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/getIndustryCpdCategory.js